import { getCache, setCache } from '@/utils/cache';
import { getSme, postSme, putSme } from '@/utils/request';
import { getCompanyIndustryFromBriefIndustry } from '@/views/sme/utils/getIndustry';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { useSmeAuthStore } from './sme-auth';

export const useSmeMerchantStore = defineStore('sme-merchant', () => {
  const smeAuthStore = useSmeAuthStore();
  const smeMerchant = computed<any>(() => smeAuthStore.smeProfile);
  const smeBrand = ref<any>(null);
  const isFetchingMerchant = ref(false);
  const isFetchingBrandInfo = ref(false);

  const brands = computed(() => {
    if (!smeMerchant.value) return null;

    const companies = smeMerchant.value.companies;

    return companies.filter((company: any) => company.company_role === 'BRAND');
  });

  const createBrand = async (form: any) => {
    try {
      const data = {
        name: form.name,
        company_industry: form.industry_name,
        managed_by_company_id: form.company_id,
        email: form.email,
        description: form.description,
        is_sme: true,
        sme: true,
      };

      const res = await postSme('/companies?is_sme=true', data);

      smeBrand.value = res;
    } catch (error) {
      console.log(error);
    }
  };

  const updateBrand = async (company_id: string, form: any) => {
    try {
      const data = {
        name: form.name,
        company_industry: form.industry_name,
        email: form.email,
        description: form.description,
      };

      const res = await putSme(`/companies/${company_id}`, data);

      smeBrand.value = res;
    } catch (error) {
      console.log(error);
    }
  };

  const getBrandInfo = async (id: string) => {
    try {
      isFetchingBrandInfo.value = true;
      const data = await getSme(`/companies/${id}`);
      smeBrand.value = data;
      // setCache('sme-brand', data);
    } catch (error) {
      console.log(error);
    } finally {
      isFetchingBrandInfo.value = false;
    }
  };

  return {
    smeMerchant,
    smeBrand,
    isFetchingMerchant,
    getBrandInfo,
    brands,
    createBrand,
    updateBrand,
  };
});
